module.exports = __webpack_public_path__ + "img/thumb_08.eade863c.jpg";